import React from 'react';
import AttachmentLookup from '../../components/attachment-lookup/attachment-lookup';

const AttachmentLookupPage = () => (
  <div className="attachment-lookup-page">
    <AttachmentLookup />
  </div>
);

export default AttachmentLookupPage;
